import React, { useEffect, useMemo, useState } from 'react'
import { Box } from '@mantine/core';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Button } from 'react-bootstrap';
import { BsFillPencilFill } from 'react-icons/bs';
import { ModalDivisi } from '../../../Modal';

function TableDivisiDark({
    tokenUser,
    listDivisiTable,
    retrieveDivisi,
}) {

    const [rowSelected, setRowSelected] = useState();
    const [mode, setMode] = useState('')
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => {
        setShowModal(true);
        setMode('Tambah');
        setRowSelected(null);
    };

    const handleShowModalEdit = (row) => {
        setShowModal(true);
        setRowSelected(row);
        setMode('Ubah');
    };

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = listDivisiTable.map(({ ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {

                return {
                    ...data,
                };
            })
        );
    }, [listDivisiTable]);


    const columns = useMemo(
        () => [
            {
                header: 'Nama Divsi',
                accessorKey: 'name',
                mantineTableHeadCellProps: {
                    align: 'left',
                },
                size: 50,
                mantineTableBodyCellProps: {
                    align: 'left',
                },
            },
            {
                header: 'Ubah',
                accessorFn: row => (
                    <div >
                        <Button variant='btn' onClick={() => handleShowModalEdit(row)}>
                            &nbsp;<BsFillPencilFill size={20} color='#D2DC02' />&nbsp;
                        </Button>
                    </div>
                ),
                size: 50,
                mantineTableHeadCellProps: {
                    align: 'right',
                },
                mantineTableBodyCellProps: {
                    align: 'right',
                },
            },
        ],
        [],
    );

    const table = useMantineReactTable({
        columns,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        initialState: {
            density: 'xs',
            sorting: [
                {
                    id: 'name',
                    asc: true,
                },
            ],
        },
        data: dataTable,
        enableRowNumbers: true,
        rowNumberMode: 'static',
        isMultiSortEvent: () => true,
        mantineTableProps: { highlightOnHover: false },
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    id='buttonTambahTableDark'
                    variant="btn"
                    onClick={handleShowModal}
                >
                    Tambah

                </Button>
            </Box>
        ),
    });

    return (
        <div>
            <MantineReactTable
                table={table}
            />

            <ModalDivisi
                rowSelected={rowSelected}
                showModal={showModal}
                setShowModal={setShowModal}
                retrieveDivisi={retrieveDivisi}
                tokenUser={tokenUser}
                mode={mode}
            />

        </div>
    )
}

export default TableDivisiDark
